import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';

const { formatImage } = require('@ifeng/public_method');

class BottomBanner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        base62Id: PropTypes.string,
    };

    slideBox = React.createRef();

    state = {
        hideAnimation: true,
        flage: false,
        resetData: [],
    };

    timer = null;
    animationCountNum = 0;

    componentDidMount() {
        const { content, base62Id } = this.props;
        const resetData = [];

        if (content.item && content.item.length) {
            const addNum = content.type !== 'hotmerge' ? 2 : 1;
            const contentList = content.item.map((item, index) => {
                return {
                    ...item,
                    countId: index + 1,
                };
            });

            for (let i = 0; i < contentList.length; i += addNum) {
                resetData.push(contentList.slice(i, i + addNum));
            }
        }

        this.setState({
            resetData,
        });

        if (resetData.length >= 2) {
            this.timer = setInterval(() => {
                this.setState({
                    flage: true,
                });
            }, 5000);
        }

        h5PageCount([
            {
                behavior: 'action',
                type: 'hotdoc',
                other: {
                    ref: `ucms_${base62Id}`,
                    kind: 'article',
                },
            },
        ]);

        this.handleAnimation();
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    handleAnimation = () => {
        this.slideBox.current.addEventListener(
            'webkitAnimationEnd',
            () => {
                this.animationCountNum++;

                if (this.animationCountNum === 2) {
                    const { resetData } = this.state;
                    const interimData = resetData;
                    const firstData = interimData.shift();

                    interimData.push(firstData);

                    this.setState({
                        flage: false,
                        resetData: interimData,
                    });
                    this.animationCountNum = 0;
                }
            },
            false,
        );
    };

    handleFeed = () => {
        const { flage, resetData } = this.state;

        return (
            <div className={`${styles.bottomBannerBox} ${flage ? styles.cardAnimation : ''}`} ref={this.slideBox}>
                {resetData.slice(0, 2).map((outItem, outIndex) => {
                    return (
                        <div key={outIndex} className={styles.bottomBannerItem}>
                            {outItem.map((inItem, inIndex) => {
                                const weburl = (inItem.link && inItem.link.weburl) || '';
                                // const catename = (inItem.subscribe && inItem.subscribe.catename) || '';
                                // const commentNum = inItem.commentsall || '';
                                const thumbnail =
                                    (inItem.thumbnail &&
                                        formatImage(
                                            inItem.thumbnail
                                                .replace(/_webp/, '')
                                                .replace(/png\.webp/, 'png')
                                                .replace(/jpg\.webp/, 'jpg'),
                                            196,
                                            132,
                                        )) ||
                                    '';
                                let pageType = inItem.type === 'phvideo' ? 'phvideo' : 'article';

                                pageType = inItem.type === 'web' || !inItem.type ? 'web' : pageType;
                                let newId =
                                    (inItem.link &&
                                        inItem.link.weburl &&
                                        inItem.link.weburl.split('?') &&
                                        inItem.link.weburl.split('?')[0] &&
                                        inItem.link.weburl.split('?')[0].split('/') &&
                                        inItem.link.weburl
                                            .split('?')[0]
                                            .split('/')
                                            .pop()) ||
                                    inItem.id ||
                                    '';

                                newId = pageType === 'web' ? inItem?.link?.weburl : newId;

                                return (
                                    <>
                                        <div
                                            key={inIndex}
                                            onClick={this.handlebottomBannerFeedClick.bind(
                                                this,
                                                inItem.countId,
                                                pageType,
                                                weburl,
                                                newId,
                                            )}
                                            className={styles.bottomBannerFeed}>
                                            <WxLaunchApp
                                                launchType="app"
                                                launchAppClick={() => {
                                                    this.handlebottomBannerFeedClick(
                                                        inItem.countId,
                                                        pageType,
                                                        weburl,
                                                        newId,
                                                        true,
                                                        false,
                                                        false,
                                                    );
                                                }}
                                                schemeLink={getSchemeLink({
                                                    docType: pageType,
                                                    pid: newId,
                                                    kind: 'share01',
                                                })}
                                                launchAppFail={() => {
                                                    this.handlebottomBannerFeedClick(
                                                        inItem.countId,
                                                        pageType,
                                                        weburl,
                                                        newId,
                                                        false,
                                                        true,
                                                        true,
                                                    );
                                                }}
                                            />
                                            <div className={styles.bottomBannerFeedText}>
                                                <h2 className={styles.bottomBannerFeedTitle}>{inItem.title}</h2>
                                                {/* <div className={styles.bottomBannerFeedTag}>
                                                    {catename && (
                                                        <span className={styles.bottomBannerFeedTip}>{catename}</span>
                                                    )}
                                                    {commentNum && (
                                                        <span className={styles.bottomBannerFeedTip}>
                                                            {commentNum}评
                                                        </span>
                                                    )}
                                                </div> */}
                                                <div className={styles.bottomBannerFeedOpenApp}>打开APP阅读</div>
                                            </div>
                                            {thumbnail && (
                                                <img className={styles.bottomBannerFeedImg} src={thumbnail} />
                                            )}
                                        </div>
                                        {/* {inItem.hotLabel &&
                                            inItem.hotLabel.desp &&
                                            inItem.hotLabel.link &&
                                            inItem.hotLabel.link.weburl && (
                                                <a
                                                    href={inItem.hotLabel.link.weburl}
                                                    onClick={this.handleCardHead.bind(
                                                        this,
                                                        2,
                                                        'newsgroup',
                                                        inItem.hotLabel.link.staticId,
                                                    )}
                                                    className={styles.bottomBannerMore}>
                                                    <span className={styles.bottomBannerMoreText}>
                                                        {inItem.hotLabel.desp}
                                                    </span>
                                                </a>
                                            )} */}
                                    </>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    handleCardHead = (key = 0, artType, url, goId) => {
        const { content, base62Id } = this.props;
        const type = artType || '';
        const id = goId ? goId : content.id;
        const tag = 't71';
        const rnum = `${tag}_${key}`;

        // if (content.type === 'hotmerge') {
        //     tag = 't74';
        //     rnum = `${tag}_${key - 1}`;
        // }

        h5PageCount([
            {
                behavior: 'page',
                type,
                other: {
                    id,
                    tag,
                    rnum,
                    ref: `ucms_${base62Id}`,
                    url: encodeURIComponent(url),
                },
            },
        ]);
    };

    handlebottomBannerFeedClick = (
        key = 0,
        artType,
        url,
        goId,
        isSendCount = true,
        isJumpQQlink = false,
        isCallApp = true,
    ) => {
        const { content, base62Id } = this.props;
        const type = artType || '';
        const id = goId ? goId : content.id;
        const tag = 't71';
        const rnum = `${tag}_${key}`;

        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'page',
                    type,
                    other: {
                        id,
                        tag,
                        rnum,
                        ref: `ucms_${base62Id}`,
                        url: encodeURIComponent(url),
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    behavior: 'page',
                    type,
                    tag: 't9',
                    other: {
                        id,
                        tag,
                        rnum,
                        ref: `ucms_${base62Id}`,
                        url: encodeURIComponent(url),
                    },
                },
            ]);
        }

        if (isCallApp) {
            callApp({
                docType: artType,
                pid: goId,
                kind: 'share01',
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1485368339618',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8838',
            });
        }
    };

    // 测试数据 原创：81Zjyx4TL67 热点：81gTkinKu5W 专题：7ysMOZIiqBc 话题：81ZrHVJnbc9
    render() {
        const { content } = this.props;
        let cardType = '';

        if ((content.type === 'topic3' && content.icon === '热点') || content.type === 'hotspotlist') {
            cardType = 'newsgroup';
        }
        if (content.type === 'topic3' && content.icon === '专题') {
            cardType = 'topic';
        }

        return (
            <>
                {/* 原创 */}
                {content.type === 'solenewslist' && (
                    <div className={styles.bottomBanner}>
                        <a
                            href={content.h5url}
                            onClick={this.handleCardHead.bind(this, 0, 'contents', content.h5url, '')}
                            className={styles.bottomBannerYcHead}>
                            {content.logo && (
                                <img className={styles.bottomBannerYcPic} src={formatImage(content.logo, 52, 52)} />
                            )}
                            <span className={styles.bottomBannerTitle}>{content.title}</span>
                        </a>
                        {this.handleFeed()}
                    </div>
                )}
                {/* 热点&&专题&&话题 */}
                {(content.type === 'topic3' || content.type === 'hotspotlist') && (
                    <div className={styles.bottomBanner}>
                        <a
                            href={content.h5url}
                            onClick={this.handleCardHead.bind(this, 0, cardType, content.h5url, '')}
                            className={styles.bottomBannerRdHead}>
                            {content.type === 'hotspotlist' && (
                                <img
                                    className={styles.bottomBannerRdHeadPic}
                                    src="https://x0.ifengimg.com/ucms/2020_48/11015A4B6842485F5D2B5EEBAEDE7E2E48C6E161_w56_h34.png"
                                />
                            )}
                            {content.type === 'topic3' &&
                                content.icon === '专题' && (
                                    <img
                                        className={styles.bottomBannerRdHeadPic}
                                        src="https://x0.ifengimg.com/ucms/2020_48/88FFDCDB6423F89E0C926F9C57328F98A9FD9237_w56_h34.png"
                                    />
                                )}
                            {content.type === 'topic3' &&
                                content.icon === '热点' && (
                                    <img
                                        className={styles.bottomBannerRdHeadPic}
                                        src="https://x0.ifengimg.com/ucms/2020_48/FB2432A40D583FC648BA544834D91E1994F7904F_w56_h34.png"
                                    />
                                )}
                            <span className={styles.bottomBannerTitle}>{content.title}</span>
                        </a>
                        {this.handleFeed()}
                    </div>
                )}
                {/* 热榜 */}
                {/* {content.type === 'hotmerge' && (
                    <div className={styles.bottomBanner}>
                        <div className={styles.bottomBannerRbHead}>
                            <img
                                className={styles.bottomBannerRbHeadPic}
                                src="https://x0.ifengimg.com/ucms/2020_48/7341619B27690B7EF99E2383BE721A8C4818A696_w38_h38.png"
                            />
                            <span className={styles.bottomBannerTitle}>{content.title}</span>
                        </div>
                        {this.handleFeed()}
                    </div>
                )} */}
            </>
        );
    }
}

export default errorBoundary(BottomBanner);
